"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CalendarDay = _interopRequireDefault(require("./CalendarDay"));
const CalendarWeek = _ref => {
  let {
    value,
    onSelect
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "calendarWeek"
  }, value.days.map((day, idx) => {
    const {
      date,
      overlap,
      selected
    } = day;
    return /*#__PURE__*/_react.default.createElement(_CalendarDay.default, {
      key: idx,
      date: date,
      disabled: overlap,
      selected: selected,
      onClick: onSelect
    });
  }));
};
process.env.NODE_ENV !== "production" ? CalendarWeek.propTypes = {
  value: _propTypes.default.any.isRequired,
  onSelect: _propTypes.default.func
} : void 0;
CalendarWeek.defaultProps = {
  onSelect: undefined
};
var _default = exports.default = /*#__PURE__*/_react.default.memo(CalendarWeek);